var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('xolas-table',{attrs:{"table-ref":"insurance-table","title":"Insurance","icon":"fa fa-shield-alt","hide-org-badge":"","show-search":false,"url":'/insurance/site/' + _vm.rowData.id,"fields":_vm.fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }